import * as Cookie from '../cookie';
import * as Ajax from "../../../pwa/ajax";

const urlApiPaywall = window.config.Statics.ApiPaywall;
const urlApiSuscripcion = urlApiPaywall + window.config.Statics.ApiSuscripcion; 

export const MakeCustomDimension = () => {
    
    //let timeCache = localStorage.getItem("CDcacheCommon");
   // let dif = 0;  
    // let tiempoCacheMilisegundos = 300000; ///TODO:Cambiar a configuracion
    let cDlocalStorage = localStorage.getItem("CDusuarioLogeado");
    if (cDlocalStorage == null) {
        getAndSaveCustomDimension();
    }

    //if (timeCache) {
    //    dif = Date.now() - timeCache;
    //    if (dif > tiempoCacheMilisegundos) {
    //        cleanAndGetCustomDimensions();
    //    } else {
    //        let tokenActual = Cookie.LeerCookie('token');
    //        let cDtoken = localStorage.getItem("token");
    //        if (tokenActual && tokenActual !== cDtoken) {
    //            localStorage.removeItem("CDnotasLeidas");
    //            cleanAndGetCustomDimensions();
    //        }
    //    }
    //} else {
    //    getAndSaveCustomDimension();
    //}
}

const getAndSaveCustomDimension = () => {
    
    //let usuarioLogeado = Cookie.LeerCookie('token');
    let usuarioLogeado = localStorage.getItem("token");
    let productoId = Cookie.LeerCookie('ProductoPremiumId');
    let clubLn = Cookie.LeerCookie('usuarioDetalleClubNacion');
    let userId = Cookie.LeerCookie('usuario%5Fid');
    let usuarioRegistrado = Cookie.LeerCookie('usuarioemail');

    if (usuarioLogeado != null) {
        getSuscriptorType(usuarioLogeado);
    } else {
        localStorage.setItem("CDsuscriptorType", "N/A");
    }

    usuarioLogeado = usuarioLogeado != null ? true : false;
    productoId = productoId ? true : false;
    clubLn = clubLn ? clubLn : "N/A";
    userId = userId ? userId : "N/A";
    usuarioRegistrado = usuarioRegistrado ? true :false;

    localStorage.setItem("CDcacheCommon", Date.now());
    localStorage.setItem("CDusuarioLogeado" , usuarioLogeado);
    localStorage.setItem("CDpayUser" , productoId);
    localStorage.setItem("CDcredentialType" , clubLn);
    localStorage.setItem("CDuserId" , userId);
    localStorage.setItem("CDusuarioRegistrado" , usuarioRegistrado);

}

const cleanAndGetCustomDimensions = () => {
    
    localStorage.removeItem("CDcacheCommon");
    localStorage.removeItem("CDusuarioLogeado");
    localStorage.removeItem("CDusuarioRegistrado");
    localStorage.removeItem("CDpayUser");
    localStorage.removeItem("CDsuscriptorType");
    localStorage.removeItem("CDcredentialType");
    localStorage.removeItem("CDuserId");
    getAndSaveCustomDimension();
}

const getSuscriptorType = (token) => {
    let objHeaders = {
        "X-Token": token
    }
    Ajax.post(urlApiSuscripcion ,undefined, objHeaders)
        .then((rs) => saveSuscriptorType(JSON.parse(rs)));

}

const saveSuscriptorType = (data) => {
    if (data && data.code && data.code === "0000") {
        let combo = data.response.nombre;
        localStorage.setItem("CDsuscriptorType", combo);
    } else {
        localStorage.setItem("CDsuscriptorType", "N/A");
    }
}


// WEBPACK FOOTER //
// ./Statics/scripts/common/analytics/CustomDimension.js